interface Props {
  className?: string;
}
export const MirrorIcon = ({ className }: Props) => {
  return (
    <svg
      viewBox="0 0 240 240"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={className}
    >
      <rect x="61" y="43" width="124" height="142" fill="transparent" />
      <path
        d="M105.067 1.3333C86.2666 4.39997 66.5332 11.8666 52.3999 21.4666C12.6665 48.5333 -7.60012 100.933 3.73322 147.2C17.1999 201.733 64.3999 239.067 120 239.067C166.933 239.067 208 212.933 228 170.267C249.6 124.133 239.333 69.0666 202.533 33.8666C191.733 23.7333 183.867 18.4 170.133 11.8666C150.667 2.79997 123.6 -1.60003 105.067 1.3333ZM136.133 58C148.267 62.4 157.2 71.0666 163.733 85.0666L167.333 92.6666L167.733 133.6C168 161.6 167.733 175.333 166.667 177.2C165.333 180 164.267 180 120 180C75.7332 180 74.6666 180 73.3332 177.2C72.2666 175.333 71.9999 161.6 72.2666 133.6L72.6666 92.6666L76.9332 83.7333C87.9999 60.4 112.533 49.7333 136.133 58Z"
        fill="currentColor"
        shapeRendering="geometricPrecision"
      />
    </svg>
  );
};
